var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransferUtglNative = function SvgTransferUtglNative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Transfer_UTGL_Native_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3 4.2h11.6v8.4h-2.175V6.3H13.3V4.2Zm-6.525 8.4v9.1H13.3v2.1H4.6V12.6h2.175Z",
    fill: "#CC8528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.25 11.2V0h11.6v11.2H.25ZM14.75 28V14h14.5v14h-14.5Z",
    fill: "#305992"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Transfer_UTGL_Native_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.25)",
    d: "M0 0h29v28H0z"
  })))));
};
export default SvgTransferUtglNative;